import {
  Component,
  OnInit
} from '@angular/core';

import { AppState } from '../app.service';
// import { Title } from './title';
// import { XLargeDirective } from './x-large';

import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { TweenMax, TimelineMax } from "gsap";
import * as $ from 'jquery/dist/jquery.min.js';
import { BrowserModule, Title }  from '@angular/platform-browser';


@Component({
  /**
   * The selector is what angular internally uses
   * for `document.querySelectorAll(selector)` in our index.html
   * where, in this case, selector is the string 'home'.
   */
  selector: 'fleet',  // <home></home>
  /**
   * We need to tell Angular's Dependency Injection which providers are in our app.
   */
  providers: [
    Title
  ],
  /**
   * Our list of styles in our component. We may add more to compose many styles together.
   */
  styles: [ require('./fleet.component.css') ],
  /**
   * Every Angular template is first compiled by the browser before Angular runs it's compiler.
   */
  template: require('./fleet.component.html')
})
export class FleetComponent implements OnInit {
  /**
   * Set our default values
   */
  public localState = { value: '' };
  sub: Subscription;
  part: string;

  cub = "assets/images/MISC_lb2.jpg";
  cub_thin = "assets/images/LCUB_lb4.jpg";
  tiger_thin = "assets/images/TIGERS_lb1.jpg";
  cap_thin = "assets/images/CAP10_lb2.jpg";
  turb_thin = "assets/images/TURB_lb4.jpg";
  offset = 250; 

  /**


   * TypeScript public modifiers
   */

   
  constructor(
    public appState: AppState,
    public title: Title,
    public activatedRoute: ActivatedRoute
  ) {}

  public ngOnInit() {
    // console.log('hello `fleet` component');
    this.title.setTitle("The Tiger Club | Our Fleet");
    this.sub = this.activatedRoute
      .params
      .subscribe(params => {
        this.part = params['part'];
        if(this.part){
          // console.log("PART IS :", this.part);
          this.scrollTo(this.part);
        }
      });

    /**
     * this.title.getData().subscribe(data => this.data = data);
     */
     // $("#main_header").addClass("after_scroll");
    //  var scene = new this.appState.ScrollMagic.Scene({
    //   triggerElement: "#trigger",
    //   duration: 60
    // })
    //   .setTween(TweenMax.to(this.test.nativeElement, 0.5, { y: -40 }))
    //   .addTo(this.appState.controller);


     
  }

  public more_tiger(){
    if($("#more_tiger").hasClass("collapsed")){
      $("#more_tiger").removeClass("collapsed");
      $("#textmebtn").html("LESS ABOUT THE TIGER MOTHS");
    } else {
      $("#more_tiger").addClass("collapsed");
      $("#textmebtn").html("MORE ABOUT THE TIGER MOTHS");
    }
  }

  public scrollTo(id){
     $('html, body').animate({
        scrollTop: $("#"+id).offset().top - 80
    }, 10);
  }

  public submitState(value: string) {
    // console.log('submitState', value);
    this.appState.set('value', value);
    this.localState.value = '';
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/fleet/fleet.component.ts